import { Avatar, Box, Typography } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(p) => p.theme.spacing(2)};
  height: 100%;
  min-height: ${(p) => p.theme.spacing(30)}; */
`;

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingContainer = styled(Box)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

export const Spinner = styled(Box)({
  width: 86,
  height: 86,
  backgroundImage: 'url("/assets/images/ellipse.svg")',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  animation: `${spin} 2s linear infinite`,
});

export const LoadingBg = styled(Box)({
  position: 'absolute',

  width: 286,
  height: 286,
  backgroundImage: 'url("/assets/images/loading-bg.svg")',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  animation: `${spin} 2s linear infinite`,
});

export const ArkLogo = styled(Avatar)({
  position: 'absolute',
  width: 70,
  height: 70,
  zIndex: 9,
});

export const LoadingText = styled(Typography)`
  background: linear-gradient(90deg, #0d3cbf 0%, #5682ff 51.44%, #0d3cbf 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  z-index: 9;
`;
